const steps = [
  { id: 1, label: "Identificação" },
  { id: 2, label: "Manifestações" },
  { id: 3, label: "Evidências" },
  { id: 4, label: "Hipóteses" },
  { id: 5, label: "Consolidação" },
  { id: 6, label: "Metodologia" },
  { id: 7, label: "Anexos" },
  { id: 8, label: "Classificação" },
  { id: 9, label: "Encerramento" }
];

const StepNavigation = ({ currentStep, onStepChange }) => (
  <div className="sticky top-[72px] z-40 border-b bg-white/90 backdrop-blur">
    <div className="max-w-4xl mx-auto px-6 py-3 overflow-x-auto">
      <div className="flex gap-2 min-w-max">
        {steps.map((step) => (
          <button
            key={step.id}
            onClick={() => onStepChange(step.id)}
            className={`rounded-full px-3 py-2 text-sm ${currentStep === step.id ? "bg-[#0F4C5C] text-white" : "bg-[#F5F2EB] text-[#4A5568]"}`}
          >
            {step.label}
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default StepNavigation;
